import { Container } from 'components/container'
import { Section, SectionTitle } from './styled'
import { Season } from './season'

const LIST_ITEMS = [
  {
    title: '',
    link: '/a/32765475.html',
    imageUrl: require('./assets/01000000-0a00-0242-1599-08dcc83821a1_w800.png'),
  },
  {
    title: '',
    link: '/a/32765475.html',
    imageUrl: require('./assets/01000000-0a00-0242-2f19-08dcc838218b_w800.png'),
  },
]

export const PreviousSeasons = () => (
  <Section id="previous-seasons">
    <SectionTitle>Предыдущие сезоны</SectionTitle>
    <Container>
      {LIST_ITEMS.map(season => (
        <Season key={season.title} {...season} />
      ))}
    </Container>
  </Section>
)
